import {
    CORE_GET_ALL_COURSE_TYPE_REQUEST,
    CORE_GET_ALL_COURSE_TYPE_SUCCESS,
    CORE_GET_ALL_COURSE_TYPE_FAILURE,

    CORE_GET_COURSE_TYPE_BY_ID_REQUEST,
    CORE_GET_COURSE_TYPE_BY_ID_SUCCESS,
    CORE_GET_COURSE_TYPE_BY_ID_FAILURE,

} from '../../settingsType'
import { REQUEST_STATE } from '../../types'

const requestState = REQUEST_STATE

export default {
    courseTypes: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_COURSE_TYPE_REQUEST:
                return state
            case CORE_GET_ALL_COURSE_TYPE_SUCCESS:
                if (action.payload) {
                    console.log(action.payload)
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_COURSE_TYPE_FAILURE:
                return []
            default:
                return state
        }
    },
    courseType: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_COURSE_TYPE_BY_ID_REQUEST:
                return state
            case CORE_GET_COURSE_TYPE_BY_ID_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_COURSE_TYPE_BY_ID_FAILURE:
                return {}
            default:
                return state
        }
    },

}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/settings/courseType.js